import { z } from 'zod';

export const CompanionContextSchema = z.object({
  sceneKey: z.string().min(1),
});

export const CompanionAskRequestSchema = z
  .object({
    intentId: z.string().optional(),
    /** Max 60 znaków; serwer normalizuje. Tekst NIGDY nie jest logowany ani doręczany P2P. */
    text: z.string().max(60).optional(),
    context: CompanionContextSchema,
  })
  .refine((v) => v.intentId !== undefined || v.text !== undefined, {
    message: 'intentId lub text wymagane',
  });
export type CompanionAskRequest = z.infer<typeof CompanionAskRequestSchema>;

export const CompanionAskResponseSchema = z.object({
  responseId: z.string().min(1),
  /** Zdanie PL pokazywane dziecku w dymku (statyczna baza serwera). */
  sentencePl: z.string().min(1),
});
export type CompanionAskResponse = z.infer<typeof CompanionAskResponseSchema>;
